import React from 'react'
import gql from "graphql-tag"
import { EditOutlined, CopyOutlined, InboxOutlined } from '@ant-design/icons'
import { recordEditUrl, recordCopyUrl, recordDashboardUrl, teamMetricsUrl } from '@/utils/url'
import SimpleIconButton from '@/components/common/simple-icon-button'
import { useGlobalContext, useRouter } from '@/components/context'
import { showNotification } from '@/state/user-interface'
import { useAppDispatch } from '@/utils/hooks'
import style from './action-buttons.module.sass'
import { useSetArchivedMutation } from './__gen/action-buttons'
import { FormsForRecordQuery } from './__gen'


gql`
    mutation setArchived(
        $id: ID!,
        $archived: Boolean!,
        $archivedBy: ID
    ) {
        record_Update(input: {
            id: $id,
            archived: $archived,
            archivedBy: $archivedBy
        }) {
            object {
                id
                archived
            }
        }
    }
`

type Props = {
    record: NonNullable<FormsForRecordQuery["record"]>
}

export default ({ record }: Props) => {
    const globalContext = useGlobalContext()
    const router = useRouter()
    const dispatch = useAppDispatch()
    const [setArchivedMutation, {loading}] = useSetArchivedMutation()
    const setArchived = () => {
        const archived = !record.archived
        setArchivedMutation({variables: {
            id: record.id,
            archived,
            archivedBy: archived ? globalContext.user.id : null,
        }}).then(() => {
            dispatch(showNotification({
                content: `${globalContext.currentModule.recordWord} ${archived ? 'archived' : 'restored'}`,
            }))
            // need to redirect here as form wont refresh record
            router.history.push(recordDashboardUrl({...globalContext, recordId: record.id}))
        })
        if (archived) {
            router.history.push(teamMetricsUrl(globalContext))
        }
    }
    return (
        <div className={style.container}>
            { !record.archived && 
                <SimpleIconButton
                    to={recordEditUrl({recordId: record.id, ...globalContext})}
                    antIcon={<EditOutlined style={{ fontSize: '1.6rem' }} />}
                    title="Edit"
                />
            }

            <SimpleIconButton
                to={recordCopyUrl({recordId: record.id, ...globalContext})}
                antIcon={<CopyOutlined style={{ fontSize: '1.6rem' }} />}
                title="Copy"
            />

            <SimpleIconButton
                onClick={setArchived}
                antIcon={<InboxOutlined style={{ fontSize: '1.6rem' }} />}
                title={record.archived ? 'Reactivate' : 'Archive'}
            />
        </div>
    )
}
